// Module
var code = "<div class=\"cr-change-arrow {{ ::$ctrl.customClass }}\" ng-class=\"::{ 'descending' : $ctrl.isDescending }\"> <span ng-transclude></span> <span>{{ ::$ctrl.isDescending ? '&#8595;' : '&#8593;' }}</span> </div> ";
// Exports
export default code;